// extracted by mini-css-extract-plugin
module.exports = {"regularFooter":"UnderwritingFooter_regularFooter__3qa9J","loanDecisionFooter":"UnderwritingFooter_loanDecisionFooter__3XEfk"};